'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var omit = require('ramda.dissocpath');

var getFieldArrayFromString = function getFieldArrayFromString() {
  var string = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];

  if (string.includes('.\\')) {
    return string.split(/\.(?!\\)/).map(function (str) {
      return str.replace(/\.\\/g, '.');
    });
  }

  return string.split('.');
};
var removeField = function removeField(object, field) {
  return omit(getFieldArrayFromString(field), object);
};

var isArrayOrObject = function isArrayOrObject(collection) {
  return Array.isArray(collection) ? 'array' : typeof collection === 'undefined' ? 'undefined' : _typeof(collection);
};
var omitFields = function omitFields(_ref) {
  var object = _ref.object;
  var fieldsToOmit = _ref.fieldsToOmit;

  if (isArrayOrObject(fieldsToOmit) !== 'array') {
    throw new Error('fieldsToOmit needs to be an array');
  }

  return fieldsToOmit.reduce(function (prev, field) {
    return removeField(prev, field);
  }, object);
};

module.exports = {
  omitFields: omitFields,
  removeField: removeField,
  getFieldArrayFromString: getFieldArrayFromString,
  isArrayOrObject: isArrayOrObject
};


//////////////////
// WEBPACK FOOTER
// ./~/fp-omit/src/handler.js
// module id = 1269
// module chunks = 2